<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="data.form.sinaisVitais.concat(data.model.sinaisVitais)"
            hide-filters
            hide-pagination
            tag="div"
        >
            <template v-slot:head(pa)="row">
                <span v-rkm-tooltip.hover title="Pressão arterial">{{row.label}}</span>
            </template>
            <template v-slot:head(temperatura)="row">
                <span v-rkm-tooltip.hover title="Temperatura">{{row.label}}</span>
            </template>
            <template v-slot:head(respiracao)="row">
                <span v-rkm-tooltip.hover title="Respiração">{{row.label}}</span>
            </template>
            <template v-slot:head(saturacao)="row">
                <span v-rkm-tooltip.hover title="Saturação">{{row.label}}</span>
            </template>
            <template v-slot:head(intensidadeDor)="row">
                <span v-rkm-tooltip.hover title="Intensidade da dor">{{row.label}}</span>
            </template>

            <template v-slot:cell(info)="row">
                <div v-if="Number.isInteger(row.item.id)">
                    <rkm-icon
                        :id="`pronto-atendimento-sinal-vital-info-${row.item.id}`"
                        class="mr-2"
                        icon="info-circle"
                    />

                    <rkm-popover
                        :target="`pronto-atendimento-sinal-vital-info-${row.item.id}`"
                        triggers="hover"
                    >
                        <div>{{ row.item.centroCusto.setor.nome }}</div>
                        <div><rkm-icon icon="user" /> {{ row.item.lotacao.profissional.nome }} - {{ row.item.lotacao.ocupacao.nome }}</div>
                        <div>Class. risco: {{ row.item.classificacaoRisco.nome }}</div>
                    </rkm-popover>

                    {{ row.item.dataHora }}
                </div>
            </template>

            <template v-slot:cell(pa)="row">
                {{row.item.pa}} {{row.item.pa ? getUnidadeMedidaSigla(row.item.paUnidadeMedidaId) : null}}
            </template>
            <template v-slot:cell(glicemia)="row">
                {{row.item.glicemia}} {{row.item.glicemia ? getUnidadeMedidaSigla(row.item.glicemiaUnidadeMedidaId) : null}}
            </template>
            <template v-slot:cell(temperatura)="row">
                {{row.item.temperatura}} {{row.item.temperatura ? getUnidadeMedidaSigla(row.item.temperaturaUnidadeMedidaId) : null}}
            </template>
            <template v-slot:cell(pulso)="row">
                {{row.item.pulso}} {{row.item.pulso ? getUnidadeMedidaSigla(row.item.pulsoUnidadeMedidaId) : null}}
            </template>
            <template v-slot:cell(respiracao)="row">
                {{row.item.respiracao}} {{row.item.respiracao ? getUnidadeMedidaSigla(row.item.respiracaoUnidadeMedidaId) : null}}
            </template>
            <template v-slot:cell(saturacao)="row">
                {{row.item.saturacao}} {{row.item.saturacao ? getUnidadeMedidaSigla(row.item.saturacaoUnidadeMedidaId) : null}}
            </template>
            <template v-slot:cell(intensidadeDor)="row">
                {{row.item.intensidadeDor}} {{row.item.intensidadeDor ? getUnidadeMedidaSigla(row.item.intensidadeDorUnidadeMedidaId) : null}}
            </template>
            <template v-slot:cell(cintura)="row">
                {{row.item.cintura}} {{row.item.cintura ? getUnidadeMedidaSigla(row.item.cinturaUnidadeMedidaId) : null}}
            </template>

            <template v-slot:cell(actions)="row">
                <rkm-button
                    :disabled="Number.isInteger(row.item.id)"
                    @click="$refs.Modal.open(row.item)"
                    color="primary"
                    small
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    :disabled="Number.isInteger(row.item.id)"
                    @click="handleDestroy(row.item)"
                    color="danger"
                    small
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import Modal from './Modal'

export default {
    data: () => ({
        fields: [
            { key: 'info', label: 'Data / Hora', class: 'col-min' },
            { key: 'pa', label: 'PA' },
            { key: 'glicemia', label: 'Glicemia' },
            { key: 'temperatura', label: 'Temp.' },
            { key: 'pulso', label: 'Pulso' },
            { key: 'respiracao', label: 'Resp.' },
            { key: 'saturacao', label: 'SaO2' },
            { key: 'intensidadeDor', label: 'Dor' },
            { key: 'cintura', label: 'Cintura' },
            { key: 'actions', label: 'Ações', class: 'col-min text-center' },
        ],
    }),
    components: { Modal },
    methods: {
        getUnidadeMedidaSigla(id) {
            const unidade = this.data.form.unidadesMedida.find(unidade => unidade.id === id);
            return unidade ? unidade.sigla : ''
        },
        handleDestroy(item) {
            const destroy = () => new Promise(resolve => {
                const index = this.data.model.sinaisVitais.findIndex(sinalVital => sinalVital.id === item.id)
                resolve(this.data.model.sinaisVitais.splice(index, 1))
            })

            this.showDeleteConfirmation('Tem certeza que deseja excluir?', destroy)
        },
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>